var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("yxtbiz-richeditor", {
    ref: "richeditor",
    attrs: {
      "max-length": _vm.maxLength,
      "app-code": "tlive",
      "org-code": "xxv2",
      "function-name": "richeditor",
      "module-name": "test",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }